<div id="activities-list" [ngClass]="activities ? 'load' : null">
  <dx-list
    *ngIf="activities"
    class="activities-list"
    [items]="activities"
    [scrollingEnabled]="false"
  >
    <div *dxTemplate="let item of 'item'">
      <div class="activity">
        <div class="name">{{ item.name }}</div>
        <div class="date" [ngClass]="{ by: showBy }">
          <span>{{ item.date | date: 'MM/dd/yyyy' }}</span>
          <span *ngIf="showBy">by</span>
          <span>{{ item.manager }}</span>
        </div>
        <card-menu [items]="activityMenuItems"> </card-menu>
      </div>
    </div>
  </dx-list>

  <dx-load-panel
    container="#activities-list"
    [position]="{ of: '#activities-list' }"
    [visible]="!activities || isLoading"
    [showPane]="false"
  ></dx-load-panel>
</div>
